<template>
  <div>
    <ErequisitionView></ErequisitionView>
  </div>
</template>
  
  <script>
const ErequisitionView = defineAsyncComponent(() =>
  import("@/components/cases/ErequisitionView")
);
import { defineAsyncComponent } from "vue";
export default {
  components: {
    ErequisitionView,
  },
};
</script>
  
